import { Helmet } from "react-helmet-async";

const SITE = "https://sell-phone-chi.preview.emergentagent.com";
const SITE_NAME = "Sell My Phone Chicago";
const DEFAULT_OG_IMAGE = "https://images.unsplash.com/photo-1714662660476-022bfd34cf44?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxjaGljYWdvJTIwc2t5bGluZSUyMGRheXxlbnwwfHx8fDE3ODYxMjc0ODB8MA&ixlib=rb-4.1.0&q=85";

export const Seo = ({ title, description, path = "/", type = "website", image, jsonLd, noindex = false }) => {
  const fullTitle = !title
    ? `${SITE_NAME} — Turn Your Electronics Into Cash`
    : title.includes(SITE_NAME)
      ? title
      : `${title} | ${SITE_NAME}`;
  const url = `${SITE}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:image" content={image || DEFAULT_OG_IMAGE} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image || DEFAULT_OG_IMAGE} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {jsonLd && jsonLd.map((obj, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(obj)}</script>
      ))}
    </Helmet>
  );
};

export const ORG_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE_NAME,
  url: SITE,
  description:
    "A Chicago electronics buyback resource helping customers sell working phones, laptops, tablets, watches, and consoles. Operated in association with 2A Electronics.",
  areaServed: "Chicago, IL",
};

export const WEBSITE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE_NAME,
  url: SITE,
};

export { SITE, SITE_NAME };
